/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesDto } from './FeesDto';
import {
    FeesDtoFromJSON,
    FeesDtoFromJSONTyped,
    FeesDtoToJSON,
    FeesDtoToJSONTyped,
} from './FeesDto';
import type { GuaranteeReferentialDto1 } from './GuaranteeReferentialDto1';
import {
    GuaranteeReferentialDto1FromJSON,
    GuaranteeReferentialDto1FromJSONTyped,
    GuaranteeReferentialDto1ToJSON,
    GuaranteeReferentialDto1ToJSONTyped,
} from './GuaranteeReferentialDto1';
import type { FunnelProductDto } from './FunnelProductDto';
import {
    FunnelProductDtoFromJSON,
    FunnelProductDtoFromJSONTyped,
    FunnelProductDtoToJSON,
    FunnelProductDtoToJSONTyped,
} from './FunnelProductDto';
import type { GuaranteeDto1 } from './GuaranteeDto1';
import {
    GuaranteeDto1FromJSON,
    GuaranteeDto1FromJSONTyped,
    GuaranteeDto1ToJSON,
    GuaranteeDto1ToJSONTyped,
} from './GuaranteeDto1';
import type { VariablesDto } from './VariablesDto';
import {
    VariablesDtoFromJSON,
    VariablesDtoFromJSONTyped,
    VariablesDtoToJSON,
    VariablesDtoToJSONTyped,
} from './VariablesDto';
import type { FunnelPricingDto } from './FunnelPricingDto';
import {
    FunnelPricingDtoFromJSON,
    FunnelPricingDtoFromJSONTyped,
    FunnelPricingDtoToJSON,
    FunnelPricingDtoToJSONTyped,
} from './FunnelPricingDto';

/**
 * 
 * @export
 * @interface ContractFunnelDto
 */
export interface ContractFunnelDto {
    /**
     * Unique identifier of the tunnel
     * @type {string}
     * @memberof ContractFunnelDto
     */
    id: string;
    /**
     * Name of the tunnel
     * @type {string}
     * @memberof ContractFunnelDto
     */
    name: string;
    /**
     * 
     * @type {FunnelProductDto}
     * @memberof ContractFunnelDto
     */
    product: FunnelProductDto;
    /**
     * 
     * @type {Array<VariablesDto>}
     * @memberof ContractFunnelDto
     */
    variables: Array<VariablesDto>;
    /**
     * 
     * @type {Array<FeesDto>}
     * @memberof ContractFunnelDto
     */
    fees?: Array<FeesDto>;
    /**
     * 
     * @type {Array<GuaranteeDto1>}
     * @memberof ContractFunnelDto
     */
    guarantees: Array<GuaranteeDto1>;
    /**
     * 
     * @type {GuaranteeReferentialDto1}
     * @memberof ContractFunnelDto
     */
    guaranteesReferential: GuaranteeReferentialDto1;
    /**
     * 
     * @type {FunnelPricingDto}
     * @memberof ContractFunnelDto
     */
    pricing: FunnelPricingDto;
    /**
     * 
     * @type {string}
     * @memberof ContractFunnelDto
     */
    supportId: string;
    /**
     * Code du support (SOLO / GROUP / CADRE) : porte le type de cartouche (individuelle / proposition de contrat de groupe / contrat cadre) et pilote l'ordre d'affichage du tarificateur (individuel → groupe → cadre).
     * @type {string}
     * @memberof ContractFunnelDto
     */
    supportCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractFunnelDto
     */
    supportLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ContractFunnelDto
     */
    contractIdentifier: string;
    /**
     * Statut du contrat collectif associé (ex. "B" brouillon, "EC" signé). Brouillon → devis à la volée uniquement ; signé → panier + contractualisation.
     * @type {string}
     * @memberof ContractFunnelDto
     */
    contractStatutCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractFunnelDto
     */
    matchScore: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFunnelDto
     */
    missingGuarantees: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFunnelDto
     */
    warningMessages?: Array<string>;
    /**
     * Critère unique d'« ajoutable au panier ». false = produit inéligible (contrainte produit : bien hors France métropolitaine, surface max…) OU erreur de tarif : la cartouche est non ajoutable, à griser, prix masqué (pricing à 0). true = ajoutable. Aucun champ « eligible » distinct : isSuccess fait foi.
     * 
     * @type {boolean}
     * @memberof ContractFunnelDto
     */
    isSuccess: boolean;
    /**
     * Renseigné quand isSuccess=false. Message multi-ligne : une puce par violation, séparées par des retours à la ligne (\n). À afficher avec white-space: pre-line.
     * 
     * @type {string}
     * @memberof ContractFunnelDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractFunnelDto
     */
    hash?: string;
}

/**
 * Check if a given object implements the ContractFunnelDto interface.
 */
export function instanceOfContractFunnelDto(value: object): value is ContractFunnelDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    if (!('guaranteesReferential' in value) || value['guaranteesReferential'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    if (!('supportId' in value) || value['supportId'] === undefined) return false;
    if (!('supportLabel' in value) || value['supportLabel'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('matchScore' in value) || value['matchScore'] === undefined) return false;
    if (!('missingGuarantees' in value) || value['missingGuarantees'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    return true;
}

export function ContractFunnelDtoFromJSON(json: any): ContractFunnelDto {
    return ContractFunnelDtoFromJSONTyped(json, false);
}

export function ContractFunnelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractFunnelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'product': FunnelProductDtoFromJSON(json['product']),
        'variables': ((json['variables'] as Array<any>).map(VariablesDtoFromJSON)),
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeesDtoFromJSON)),
        'guarantees': ((json['guarantees'] as Array<any>).map(GuaranteeDto1FromJSON)),
        'guaranteesReferential': GuaranteeReferentialDto1FromJSON(json['guaranteesReferential']),
        'pricing': FunnelPricingDtoFromJSON(json['pricing']),
        'supportId': json['supportId'],
        'supportCode': json['supportCode'] == null ? undefined : json['supportCode'],
        'supportLabel': json['supportLabel'],
        'contractIdentifier': json['contractIdentifier'],
        'contractStatutCode': json['contractStatutCode'] == null ? undefined : json['contractStatutCode'],
        'matchScore': json['matchScore'],
        'missingGuarantees': json['missingGuarantees'],
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
        'isSuccess': json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'hash': json['hash'] == null ? undefined : json['hash'],
    };
}

export function ContractFunnelDtoToJSON(json: any): ContractFunnelDto {
    return ContractFunnelDtoToJSONTyped(json, false);
}

export function ContractFunnelDtoToJSONTyped(value?: ContractFunnelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'product': FunnelProductDtoToJSON(value['product']),
        'variables': ((value['variables'] as Array<any>).map(VariablesDtoToJSON)),
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeesDtoToJSON)),
        'guarantees': ((value['guarantees'] as Array<any>).map(GuaranteeDto1ToJSON)),
        'guaranteesReferential': GuaranteeReferentialDto1ToJSON(value['guaranteesReferential']),
        'pricing': FunnelPricingDtoToJSON(value['pricing']),
        'supportId': value['supportId'],
        'supportCode': value['supportCode'],
        'supportLabel': value['supportLabel'],
        'contractIdentifier': value['contractIdentifier'],
        'contractStatutCode': value['contractStatutCode'],
        'matchScore': value['matchScore'],
        'missingGuarantees': value['missingGuarantees'],
        'warningMessages': value['warningMessages'],
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'hash': value['hash'],
    };
}

